import type { PartnerAugmentationSet } from '@shipium-corp/shipium-ts-types';
import type { CreateAugmentationSetWithLinks, EditAugmentationSetWithLinks } from '~/store/assets/types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const augmentationSets = {
  search: {
    queryKey: 'partner-management-service/augmentation-sets',
    configurationType: 'default' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerAugmentationSet[]>(
        `/partner-configuration/augmentationSets`,
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/augmentation-sets/id',
    configurationType: 'no-cache' as const,
    fn: async (augmentationSetId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerAugmentationSet>(
        `/partner-configuration/augmentationSets/${augmentationSetId}`,
      );

      return data;
    },
  },
  create: async (augmentationLinkCreate: CreateAugmentationSetWithLinks) => {
    const { data } = await GatewayAxiosClient.post<PartnerAugmentationSet>(
      `/partner-configuration/augmentationSets`,
      augmentationLinkCreate,
    );

    return { data, invalidateQueryKeys: [['partner-management-service/augmentation-sets']] };
  },
  update: async ({
    augmentationSetId,
    payload,
  }: {
    augmentationSetId: string;
    payload: EditAugmentationSetWithLinks;
  }) => {
    const { data } = await GatewayAxiosClient.put<PartnerAugmentationSet>(
      `/partner-configuration/augmentationSets/${augmentationSetId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/augmentation-sets'],
        ['partner-management-service/augmentation-sets/id', augmentationSetId],
      ],
    };
  },
};
